interface Props {
    title: string
}

export function SubTitlePage({ title }: Props) {
    return (
        <div className="w-full mt-6 lg:mt-4">
            <h2 className="text-primary dark:text-on-surface-dark font-roboto font-light uppercase text-base m-0">
                {title}
            </h2>

            <div className="flex flex-row justify-center items-end mt-2 mb-2">
                <div className="w-[5%] h-0.5 bg-secondary" />
                <div className="w-[95%] h-px bg-border-default dark:bg-border-default-dark" />
            </div>
        </div>
    )
}